import { helpers } from '@vuelidate/validators'

export default minValue =>
  helpers.withParams({ type: 'minValueExclusive', min: minValue }, value => {
    if (!helpers.req(value)) return true
    return value.constructor == Number && value > minValue
  })
